import request from '@/utils/request'

/**
 * 获取场景分类列表
 */
export function getSceneClassifyList() {
    return request.get('/app/works/classify/classifyList', {}, { token: false })
}

/**
 * 获取场景列表
 */
export function getSceneList(params = {}) {
    return request.get('/app/work/workList', params, { token: false })
}

/**
 * 获取场景详情
 * 支持未登录访问（Token 可选）
 */
export function getSceneDetail(id) {
    return request.get(`/app/work/workDetail`, { workId: id })
}

/**
 * 记录点云浏览
 * @param {number} sceneId 点云ID
 * @returns {Promise}
 */
export function recordSceneView(sceneId) {
    return request.post('/app/content/view', { contentId: sceneId, contentType: 'works' }, { token: false })
}

/**
 * 提交发布场景
 * @param {Object} data 场景数据
 * @returns {Promise}
 */
export function addWork(data) {
    return request.post('/app/work/addWork', data)
}
